<script>
    import { fly, fade } from "svelte/transition";
    import { getContext } from "svelte";
    import { display } from "../stores";
    import Exclamation from "../Icons/Exclamation.svelte";
    import ButtonHolder from "./ButtonHolder.svelte";

    const {notification} = getContext('notification');
    
    </script>
    
    <div>
        <div class="note" id="modification" transition:fly|local={{ y: 500, duration: 500 }}>
            <Exclamation/>
            <h3>Subscription alert</h3>
            <p class="mode">{$notification.text}</p>
            <div class="buttonsHolder">
                <ButtonHolder on:click={()=>notification.handle_outcome(true)}>{$notification.buttons[0]}</ButtonHolder>
                <ButtonHolder on:click={()=>notification.handle_outcome(false)}>{$notification.buttons[1]}</ButtonHolder>
            </div>
        </div>
        {#if $display === 'm'}
            <div class="blackout" transition:fade={{ duration: 400 }} />
        {/if}
    </div>
    
    <style>
    .blackout {
        display: flex;
        position: absolute;
        width: auto;
        height: 100vh;
        top: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: var(--z-index-blackout);
    }
    
    button:hover {
        cursor: pointer;
    }
    
    .buttonsHolder {
        display: flex;
        flex-direction: row;
        position: relative;
        justify-content: space-around;
        top: 7%;
        width: 100%;
        height: 20%;
    }
    
    #confirm {
        z-index: var(--z-index-notification);
    }
    
    #cancel {
        z-index: var(--z-index-notification);
    }
    
    .mode {
        overflow-y: scroll;
        white-space: normal;
    }
    
    #modification {
        display: flex;
        position: fixed;
        flex-wrap: wrap;
        height: 40%;
        top:20%;
        left: var(--display-notification_left_pos);
        min-width: 30%;
        max-width: 80%;
        width: 85%;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        
        padding: 5px;
        justify-content: space-around;
        align-items: center;
        
        z-index: var(--z-index-notification);
        background: var(--color_scheme-background);
        
        box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
        border-top: 2px solid var(--color_scheme-contrast_color);
        overflow: hidden;
    }
    
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }
    </style>